import { Headers } from '@egw/components'
import { NotFound404 } from '@egw/features-system'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const NotFound404Page: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.not_found_404.title')} />
      <NotFound404 />
    </Layout>
  )
}
